module.exports = __webpack_public_path__ + "media/images/communities/logos/ao2-ac174b11e02a673c5ef604659dbddec1.png";